import styled from "@emotion/styled";
import { colorPalette } from "../../../theme/colors";

export const BankLogoWrapper = styled.img<{
  height: number;
  width: number;
  isDefaultIcon: boolean;
}>`
  width: ${(props) => props.width || 40}px;
  height: ${(props) => props.height || 40}px;
  border: ${(props) =>
    props.isDefaultIcon ? `1px solid ${colorPalette.popBlack[100]}` : "none"};
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
`;
